import { derived, writable, Writable } from "svelte/store";

export const selectCharacterSceneVisibleStore = writable(false);
